import { render, staticRenderFns } from "./TranslateFrom.vue?vue&type=template&id=20251197&scoped=true&"
import script from "./TranslateFrom.vue?vue&type=script&lang=js&"
export * from "./TranslateFrom.vue?vue&type=script&lang=js&"
import style0 from "./TranslateFrom.vue?vue&type=style&index=0&id=20251197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20251197",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VAutocomplete,VLabel})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20251197')) {
      api.createRecord('20251197', component.options)
    } else {
      api.reload('20251197', component.options)
    }
    module.hot.accept("./TranslateFrom.vue?vue&type=template&id=20251197&scoped=true&", function () {
      api.rerender('20251197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/translate/TranslateFrom.vue"
export default component.exports